import notification from "app/config/notification";
import { fetchMaxAgeVehicle } from "app/store/slices/survey";
import { checkIfArrayIsUnique } from "app/utils/array";
import { validateDocumentsDescription } from "../functions";

function checkUniquePlates(vehicles) {
    const vehiclesPlates = vehicles.map(vehicle => {
      return vehicle.dePlaca;
    });
  
    return checkIfArrayIsUnique(vehiclesPlates);
  }

  async function checkMaxAge(vehicles) {
    if (!vehicles) return false;

    const vehiclesMaxAge = await Promise.all(vehicles.map(async v => {
      return await fetchMaxAgeVehicle({ dePlaca: v.dePlaca }, 'ext');
    }));

    return vehiclesMaxAge.some(value => value);
  }

  export const validateSurveyRequest = async ({values, vehicles, intl, isInternalForm}) => {
    const docsExtrasValidation = validateDocumentsDescription(values.documentos);
    if (!docsExtrasValidation && !isInternalForm) {
      notification(
        intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED' }),
        {
          toastId: 'MESSAGES.SERVICE.FORMS.DOCUMENT_DESCRIPTION_REQUIRED',
          type: 'error',
        }
      );
      return false;
    }
  
    // verifica se existe veiculos para adicionar
    if (vehicles.length <= 0) {
      notification('Favor incluir um ou mais veículo(s) para a vistoria', {
        toastId: 'MISSING_MANDATORY_INFOS',
        type: 'warning',
      });
      return false;
    }
  
    // verifica se já existe placas
    if (!checkUniquePlates(vehicles)) {
      notification('O veículo informado já está na solicitação. Favor alterar a placa', {
        toastId: 'MISSING_MANDATORY_INFOS',
        type: 'warning',
      });
      return false;
    }
  
    // verifica a idade do veiculo
    if (await checkMaxAge(vehicles)) {
      notification(
        'O(s) veículo(s) informado(s) está(ão) com a idade máxima permitida. Favor revisar informações enviadas.',
        {
          toastId: 'MISSING_MANDATORY_INFOS',
          type: 'warning',
        }
      );
      return false;
    }

    return true;
  };
  